import React, { Component } from 'react'
import { Field, reduxForm } from 'redux-form'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'

import Input from 'components/atoms/inputs/simpliest_input'
import OptionSelect from 'components/atoms/inputs/option_select_with_specific_label'
import { completeNewServiceStep, selectNewServiceStep, uncheckNewServiceStep } from 'actions/shared'
import { NEW_SERVICE_VIEWS, CURRENCY_OPTIONS } from 'constants/index'
import Button from 'components/atoms/buttons/solid'
import * as routes from 'constants/routes'

class NewServiceCost extends Component{
    constructor(props){
        super(props)
        this.validateCost = this.validateCost.bind(this)
        this.validateCurrency = this.validateCurrency.bind(this)
        this.validateExtraCost = this.validateExtraCost.bind(this)
    }

    validateCost(cost){
        if(!cost){
            this.props.uncheckNewServiceStep(NEW_SERVICE_VIEWS.cost)
            return 'Debes definir un costo para tu servicio'
        }
    }
    
    validateCurrency(currency_code){
        if(!currency_code){
            this.props.uncheckNewServiceStep(NEW_SERVICE_VIEWS.cost)
            return 'Debes seleccionar un tipo de moneda'
        }
    }

    validateExtraCost(cost){
        if(!cost){
            this.props.uncheckNewServiceStep(NEW_SERVICE_VIEWS.cost)
            return 'Debes definir un costo para la hora extra de tu servicio'
        }
    }

    onSubmit(values){
        this.props.completeNewServiceStep(NEW_SERVICE_VIEWS.cost)
        this.props.selectNewServiceStep(NEW_SERVICE_VIEWS.zones)
        this.props.history.push(routes.ARTIST_JOB_SERVICES_NEW)
    }

    render(){
        const { handleSubmit } = this.props
        return (
            <div className='container mt-5'>
                <form onSubmit={handleSubmit(this.onSubmit.bind(this))} className='p-2'>
                    <h4 className='text-secondary'>Costo</h4>
                    {/* <p>El precio de tu servicio debe incluir I.V.A.</p> */}
                    <Field
                        name="cost"
                        type="number"
                        placeholder="Agrega un costo"
                        validate={this.validateCost}
                        component={Input}
                    />

                    <h4 className='text-secondary mt-5'>Moneda</h4>
                    <p>Selecciona el tipo de moneda correspondiente.</p>
                    <Field
                        name="currency_code"
                        type='select'
                        placeholder="Moneda"
                        options={CURRENCY_OPTIONS}
                        validate={this.validateCurrency}
                        component={OptionSelect}
                    />

                    <h4 className='text-secondary mt-5'>Costo por hora extra</h4>
                    {/* <p>El precio de tu servicio debe incluir I.V.A.</p> */}
                    <Field
                        name="cost_extra"
                        type="number"
                        placeholder="Agrega un costo"
                        validate={this.validateExtraCost}
                        component={Input}
                    />

                    <div className='my-5 d-flex justify-content-center'>
                        <Button 
                            type='submit' 
                            color='primary' 
                            text='Guardar'
                        />
                    </div>
                </form>
            </div>
        )
    }
}

NewServiceCost = reduxForm({
    form: 'createNewServiceWizard', // <------ same form name
    destroyOnUnmount: false, // <------ preserve form data
    forceUnregisterOnUnmount: true, // <------ unregister fields on unmount
  })(NewServiceCost)
  
  NewServiceCost = connect(
    null,
    { completeNewServiceStep, selectNewServiceStep, uncheckNewServiceStep }
  )(NewServiceCost)
  
  export default withRouter(NewServiceCost)